import { Injectable } from '@angular/core';
import { HttpService } from "./http.service";
import { MerchantBillingRoles } from '../models/merchant-billing-models/merchant-billing-roles';

@Injectable({
  providedIn: 'root'
})
export class MerchantBillingRolesService {

  constructor(private _httpService: HttpService) {
  }

  public async GetById(id: string): Promise<MerchantBillingRoles> {
    const httpResult = await this._httpService.apiGet<MerchantBillingRoles>(`MerchantBillingRoles/GetById/${id}`);
    if (httpResult && httpResult.body) {
      return httpResult.body;
    }
    return null;
  }
}
